import { values } from './enums'

const _enum = {
  Enabled: 0,
  Disabled: 1
}

export const reportGroupStatus = {
  enumName: 'ReportGroupStatus',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/reportGroupStatus.js